// Delegate functions:  enables us to 'listen' for events on elements that get stuck on the page after page load, IE via AJAX, IE in livetable
Element.addMethods({
  delegate: function(element, selector, eventName, observer) {
	// observe parent container
	if(!Element.delegators) Element.delegators = {};
	var handle = element.id+selector+eventName;
	Element.delegators[handle] = function(event) {
	  // check if target element (e.g. element that was clicked or moused over)
	  //   matches given selector
	  if ($(element).select(selector).indexOf(event.target) > -1) {
		// if it matches, fire the observer (in the scope of the target element)
		return observer.apply(event.target, $A(arguments));
	  }
	}
	return $(element).observe(eventName, Element.delegators[handle]);
  },
  stopDelegating: function(element, selector, eventName, observer){
	if(!Element.delegators) return false;
	var handle = element.id+selector+eventName;
	if(!Element.delegators[handle]) return false;
	$(element).stopObserving(eventName, Element.delegators[handle]);
	return true;
  }
});
// example of delegation
/*
$('body').delegate('#container p.even', 'click', function() {
	alert('delegated!');
});
*/
// 

document.observe("dom:loaded", function() {
	if($('container')){
		$('container').delegate('.popup-holder a:not(.popup_link)', 'mouseover', function(event){
				initializePopupFor(event.element());
		});
	}
});
// */
function initializePopupFor(matchedElement) {
	// DEV-12308 (M3 2.1): the livetable row menu is a canon M3 menu now
	// (m3/_menu.scss owns the surface, animation and item states); this just toggles
	// canon .is-open on the .popup-holder anchor. Hover timing preserved from the
	// legacy bubble: 0.6s delay before showing, 300ms grace before hiding.
	var showDelay = 600;	// milliseconds
	var hideDelay = 300;	// milliseconds
	var showDelayTimer = null;
	var hideDelayTimer = null;
	var trigger = matchedElement;
	var holder = trigger.closest('.popup-holder');
	var popupDiv = holder ? holder.querySelector('.am-menu') : null;

	// Never re-initialize the popup for a trigger we've already wired. DEV-12965:
	// this flag used to be classList.add('popup_link') - but livetable row anchors
	// render with NO class attribute, and the dark theme inks bare links via
	// a:not([class]) (m3/_dark-legacy.scss). Adding ANY class on first hover
	// silently flipped hovered product links from primary to on-surface white,
	// permanently. State flags on elements must be data attributes, not classes.
	if (trigger.hasAttribute('data-popup-init')) return;
	trigger.setAttribute('data-popup-init', '1');

	if (!holder || !popupDiv || popupDiv.querySelectorAll('.am-menu__item').length === 0) return; // only if there are options in the menu

	function popupMouseOver() {
		if (hideDelayTimer) { clearTimeout(hideDelayTimer); hideDelayTimer = null; }
		if (holder.classList.contains('is-open') || showDelayTimer) return;
		showDelayTimer = setTimeout(function () {
			showDelayTimer = null;
			holder.classList.add('is-open');
		}, showDelay);
	}
	function popupMouseOut() {
		if (showDelayTimer) { clearTimeout(showDelayTimer); showDelayTimer = null; }
		if (hideDelayTimer) clearTimeout(hideDelayTimer);
		hideDelayTimer = setTimeout(function () {
			hideDelayTimer = null;
			holder.classList.remove('is-open');
		}, hideDelay);
	}
	[trigger, popupDiv].forEach(function (element) {
		element.addEventListener('mouseover', popupMouseOver);
		element.addEventListener('mouseout', popupMouseOut);
	});
	popupMouseOver(); //do mouse over now so we dont have to re-mouse-over to get the popup
}//end of initializePopupFor

//HERE IS WHAT THE HTML SHOULD LOOK LIKE FOR ONE OF THESE:
/*
<div class="popup-holder am-menu-anchor"><a href="accounts/contacts/1234">Jake Lundblade</a>
  <div class="popup am-menu">
	<a href="" class='am-menu__item popup_link'>Info</a>
	<a href="" class='am-menu__item popup_link'>Tasks</a>
	<a href="" class='am-menu__item popup_link'>{'LANG_PAYMENTS'|translate|ucfirst}</a>
	<a href="" class='am-menu__item popup_link'>Something else we would want to do with a contact</a>
  </div>
</div>
*/